import { useTranslation } from 'react-i18next';

export function FAQSection() {
  const { t } = useTranslation();

  const faqs = [
    { 
      q: t('faq.deliveryTime.q'), 
      a: t('faq.deliveryTime.a')
    },
    { 
      q: t('faq.shipping.q'), 
      a: t('faq.shipping.a'),
      withLogo: true
    },
    { 
      q: t('faq.paymentMethods.q'), 
      a: t('faq.paymentMethods.a'),
      withPaymentLogos: true
    },
    { 
      q: t('faq.formats.q'), 
      a: t('faq.formats.a')
    },
    { 
      q: t('faq.materials.q'), 
      a: t('faq.materials.a')
    },
  ];

  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl lg:text-4xl font-bold text-center mb-12">
          {t('faq.title')}
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="bg-gray-50 rounded-lg p-6 cursor-pointer hover:bg-gray-100 transition-colors">
              <summary className="font-semibold text-lg mb-2 list-none cursor-pointer flex items-center justify-between">
                <span>{faq.q}</span>
                <span className="text-green-dark text-xl">+</span>
              </summary>
              <div className="text-gray-600 mt-2">
                <p>{faq.a}</p>
                {faq.withLogo && (
                  <div className="mt-3">
                    <img 
                      src="/posti_logo.png" 
                      alt="Posti" 
                      className="h-12 w-auto rounded-lg"
                    />
                  </div>
                )}
                {faq.withPaymentLogos && (
                  <div className="mt-4 space-y-3">
                    <div className="flex flex-wrap items-center gap-3">
                      <img 
                        src="/visa_logo.png" 
                        alt="VISA" 
                        className="h-8 w-auto rounded"
                      />
                      <img 
                        src="/mastercard_logo.png" 
                        alt="MasterCard" 
                        className="h-8 w-auto rounded"
                      />
                      <img 
                        src="/paypal_logo.png" 
                        alt="PayPal" 
                        className="h-8 w-auto rounded"
                      />
                      <img 
                        src="/google_pay_logo.svg" 
                        alt="Google Pay" 
                        className="h-8 w-auto rounded"
                      />
                    </div>
                  </div>
                )}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

